import React from "react";

import {Button, Card, Collapse, Descriptions, notification, Space} from "antd"
import ApiService from "../../../../services/ApiService"
import TextDataField from "./TextDataField";
import {CloseCircleOutlined, LockOutlined} from "@ant-design/icons"

import IntlMessage from "../../../../components/util-components/IntlMessage";
import SelectDataField from "./SelectDataField";
import {removeFieldType} from "../../../editors/WebEditor/formPlugins";
import CheckboxDataField from "./CheckboxDataField";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import ModalContact from "../../../../modals/ModalContact";
import DateDataField from "./DateDataField";
import UploadDataField from "./UploadDataField";
import FreeAmountDataField from "./FreeAmountDataField";
import ContactDataField from "./ContactDataField";
import PaiementMethodDataField from "./PaiementMethodDataField";
import CalendarDataField from "./CalendarDataField";
import ChildDataField from "./ChildDataField";
import HazkaraDataField from "./HazkaraDataField";
import PermissionAlert from "../../../../components/permissions/PermissionAlert";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {currencyFormat, getDevise} from "../../../../components/permissions/functions";
import {MobCard} from "../../../../mobile/components/MobCard";
import {MOBCOLORS, MOBILE_PREFIX_PATH} from "../../../../configs/AppConfig";
import {t} from "@lingui/core/macro";
import {useNavigate} from "react-router-shim";
import {withActionSheet} from "../../../../mobile/providers/ActionSheetProvider";
import {Trans} from "@lingui/react/macro";
import {DynamicIcon} from "lucide-react/dynamic";

class FicheSubmit extends React.Component {

    state = {
        loading: true,
        edit: false,
        submit: {}
    }

    properties = []

    componentDidMount() {
        this.getData()
    }

    async getData() {
        var res = await ApiService.get("/forms_submit/id/" + this.props.id)
        console.log(res)
        if (res.success) {
            this.setState({loading: false, submit: res.data})
        }
    }


    componentsKeys = [
        {keys: ["[TEXT]_", "[NUMBER]_"], component: TextDataField},
        {keys: ["[SELECT]_", "[SELECT_MULTI]_"], component: SelectDataField},
        {keys: ["[CHECKBOX]_"], component: CheckboxDataField},
        {keys: ["[DATE]_", "[DATETIME]_", "[YEAR]_", "[MONTH]_", "[TIME]_"], component: DateDataField},
        {keys: ["[DOCUMENT]_", "[DOCUMENT_MULTI]_"], component: UploadDataField},
        {keys: ["[FREE_AMOUNT]_"], component: FreeAmountDataField},
        {keys: ["[CONTACT]_"], component: ContactDataField},
        {keys: ["[CHILD]_"], component: ChildDataField},
        {keys: ["[HAZKARA]_"], component: HazkaraDataField},
        {keys: ["__paiementMethod"], label: "Moyen de Paiement", component: PaiementMethodDataField},
        {keys: ["[CALENDAR]_"], component: CalendarDataField},
    ]

    getPropertieComponent(key) {
        for (var c of this.componentsKeys) {
            for (var k of c.keys) {
                if (key.startsWith(k)) {
                    return c.component
                }
            }
        }
        return null
    }

    getPropertieLabel(key) {
        for (var c of this.componentsKeys) {
            for (var k of c.keys) {
                if (key.startsWith(k)) {
                    if (key.startsWith("[CALENDAR]_")) {
                        const calId = removeFieldType(key)
                        const cal = this.state.submit.form?.calendars.find(i => i.id === calId)
                        return cal?.label || "Calendrier"
                    }

                    return c.label || removeFieldType(key)
                }
            }
        }
        return null
    }

    onChange(key, value, root = "") {
        const propIndex = this.properties.findIndex(i => i.root === root && i.key === key)
        if (propIndex === -1) {
            this.properties.push({key: key, root: root, value: value})
        } else {
            this.properties[propIndex].value = value
        }
    }

    async onEdit() {
        var data = []

        for (var p of this.properties) {
            if (p.value === null && p.value === undefined) {
                continue
            }
            if (Array.isArray(p.value) && p.value.length === 0) {
                continue
            }

            data.push(p)
        }

        this.setState({edit: false})
        await ApiService.post("/forms_submit/edit/" + this.props.id, {props: data})

        notification.success({
            message: (<IntlMessage id="success.edit"/>)
        })

        this.properties = []
        await this.getData()
    }

    onEditCancel() {
        this.setState({edit: false})
        this.properties = []
    }

    renderDesktop() {

        const submit = this.state.submit
        var form = null
        var mainForm = null

        if (!this.state.loading) {
            form = submit.form
            mainForm = submit.data
        }

        return (
            <PermissionAlert permissions={["submit.read"]}>
                <Card type="inner" extra={(
                    <>
                        {!this.state.edit && (
                            <PermissionHidden permissions={["submit.edit"]}>
                                <Button type={"primary"} danger icon={<LockOutlined/>}
                                        onClick={() => this.setState({edit: true})}>Éditer</Button>
                            </PermissionHidden>
                        )}

                        {this.state.edit && (
                            <Space>
                                <Button type={"primary"} onClick={() => this.onEdit()}>Valider</Button>
                                <Button danger type={"ghost"} icon={<CloseCircleOutlined/>}
                                        onClick={() => this.onEditCancel()}>Annuler</Button>
                            </Space>
                        )}
                    </>
                )} loading={this.state.loading}>
                    {!this.state.loading && (
                        <>
                            <Descriptions
                                bordered
                                column={{
                                    xxl: 1,
                                    xl: 1,
                                    lg: 1,
                                    md: 1,
                                    sm: 1,
                                    xs: 1,
                                }}
                            >
                                {submit.contact && (
                                    <Descriptions.Item label={"Contact"}>
                                        <Button icon={<ContactIcon contact={submit.contact}/>} type="link"
                                                onClick={() => this.modalContact.show(submit.contact.id)}>{submit.contact.nom} {submit.contact.prenom}</Button>
                                    </Descriptions.Item>
                                )}
                                {Object.keys(mainForm).map((k, index) => {
                                    const Component = this.getPropertieComponent(k)
                                    //console.log(Component)
                                    if (!Component) {
                                        return null
                                    }

                                    return (
                                        <Descriptions.Item label={this.getPropertieLabel(k)}>
                                            <Component key={index} edit={this.state.edit} propertie={k} value={mainForm[k]}
                                                       form={form} onChange={(v) => this.onChange(k, v)}/>
                                        </Descriptions.Item>
                                    )
                                })}

                                {submit.formData.products && (
                                    submit.formData.products.map(p => {
                                        const quantity = mainForm[p.id + "_quantity"]
                                        //console.log(quantity)

                                        let montant=p.montant
                                        if(submit.devise!==getDevise()){
                                            montant=p[submit.devise].montant
                                        }

                                        if (quantity > 0) {
                                            return (
                                                <Descriptions.Item label={p.label + ' (' + currencyFormat(montant,submit.devise) + ')'}>
                                                    {quantity}
                                                </Descriptions.Item>
                                            )
                                        }

                                        return null
                                    })
                                )}
                            </Descriptions>

                            {submit.formData.products && (
                                submit.formData.products.map(p => {
                                    const quantity = mainForm[p.id + "_quantity"]
                                    //console.log(quantity)

                                    if (quantity > 0 && Array.isArray(mainForm[p.id])) {
                                        var collapseProps = {}
                                        if (this.props.defaultOpen) {
                                            collapseProps.activeKey = mainForm[p.id].map((_, cpIndex) => cpIndex)
                                        }

                                        return (
                                            <Collapse style={{marginTop: 20}} {...collapseProps}>
                                                {mainForm[p.id].map((cp, cpIndex) => {
                                                    return (
                                                        <Collapse.Panel key={cpIndex}
                                                                        header={p.label + " (" + (cpIndex + 1) + ")"}>
                                                            <Descriptions
                                                                bordered
                                                                column={{
                                                                    xxl: 1,
                                                                    xl: 1,
                                                                    lg: 1,
                                                                    md: 1,
                                                                    sm: 1,
                                                                    xs: 1,
                                                                }}
                                                            >
                                                                {cp.contact && (
                                                                    <Descriptions.Item label={"Contact"}>
                                                                        <Button icon={<ContactIcon contact={cp.contact}/>}
                                                                                type="link"
                                                                                onClick={() => this.modalContact.show(cp.contact.id)}>{cp.contact.nom} {cp.contact.prenom}</Button>
                                                                    </Descriptions.Item>
                                                                )}

                                                                {Object.keys(cp).map((k, index) => {
                                                                    const Component = this.getPropertieComponent(k)
                                                                    if (!Component) {
                                                                        return null
                                                                    }

                                                                    return (
                                                                        <Descriptions.Item label={removeFieldType(k)}>
                                                                            <Component key={index} edit={this.state.edit}
                                                                                       propertie={k} value={cp[k]}
                                                                                       form={form}
                                                                                       onChange={(v) => this.onChange(k, v, p.id + "/" + cpIndex)}/>
                                                                        </Descriptions.Item>
                                                                    )
                                                                })}
                                                            </Descriptions>
                                                        </Collapse.Panel>
                                                    )
                                                })}
                                            </Collapse>
                                        )
                                    }

                                    return null
                                })
                            )}
                        </>
                    )}


                    <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                    }}/>
                </Card>
            </PermissionAlert>
        );
    }


    renderMobile() {

        const submit = this.state.submit
        var form = null
        var mainForm = null

        if (!this.state.loading) {
            form = submit.form
            mainForm = submit.data
        }

        return (
            <PermissionAlert permissions={["submit.read"]}>
                <>
                    {!this.state.loading && (
                        <>
                            <Section>
                                {submit.contact &&(
                                    <Item name={(<Trans>Contact</Trans>)}>
                                        <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline"}} onClick={()=>{
                                            //this.props?.sheetContext?.cancel()
                                            //this.props.navigate(MOBILE_PREFIX_PATH+"/contacts/fiche?id="+submit.contact.id)
                                            this.props?.sheetContext?.openContact(submit.contact)
                                        }}>
                                            <DynamicIcon name={"contact"} color={MOBCOLORS.blue.color} size={18}/>
                                            {submit.contact?.nom} {submit.contact?.prenom}
                                        </span>
                                    </Item>
                                )}

                                {Object.keys(mainForm).map((k, index) => {
                                    const Component = this.getPropertieComponent(k)
                                    //console.log(Component)
                                    if (!Component) {
                                        //console.error("UNABLE TO FIND COMPONENT FOR",k,mainForm[k])
                                        return null
                                    }

                                    return (
                                        <Item name={this.getPropertieLabel(k)}>
                                            <Component {...this.props} key={index} edit={this.state.edit} propertie={k} value={mainForm[k]}
                                                       form={form} onChange={(v) => this.onChange(k, v)}/>
                                        </Item>
                                    )
                                })}

                                {submit.formData.products && (
                                    submit.formData.products.map(p => {
                                        const quantity = mainForm[p.id + "_quantity"]
                                        //console.log(quantity)

                                        let montant=p.montant
                                        if(submit.devise!==getDevise()){
                                            montant=p[submit.devise].montant
                                        }

                                        if (quantity > 0) {
                                            return (
                                                <Item name={p.label + ' (' + currencyFormat(montant,submit.devise) + ')'}>
                                                    {quantity}
                                                </Item>
                                            )
                                        }

                                        return null
                                    })
                                )}
                            </Section>

                            {submit.formData.products && (
                                submit.formData.products.map(p => {
                                    const quantity = mainForm[p.id + "_quantity"]
                                    //console.log(quantity)

                                    if (quantity > 0 && Array.isArray(mainForm[p.id])) {
                                        var collapseProps = {}
                                        if (this.props.defaultOpen) {
                                            collapseProps.activeKey = mainForm[p.id].map((_, cpIndex) => cpIndex)
                                        }

                                        return (
                                            <Collapse style={{marginTop: 20}} {...collapseProps}>
                                                {mainForm[p.id].map((cp, cpIndex) => {
                                                    return (
                                                        <Collapse.Panel key={cpIndex}
                                                                        header={p.label + " (" + (cpIndex + 1) + ")"}>
                                                            <Section>
                                                                {cp.contact &&(
                                                                    <Item name={(<Trans>Contact</Trans>)}>
                                                                        <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline"}} onClick={()=>{
                                                                            //this.props?.sheetContext?.cancel()
                                                                            //this.props.navigate(MOBILE_PREFIX_PATH+"/contacts/fiche?id="+cp.contact.id)
                                                                            this.props?.sheetContext?.openContact(cp.contact)
                                                                        }}>
                                                                            <DynamicIcon name={"contact"} color={MOBCOLORS.blue.color} size={18}/>
                                                                            {cp.contact?.nom} {cp.contact?.prenom}
                                                                        </span>
                                                                    </Item>
                                                                )}

                                                                {Object.keys(cp).map((k, index) => {
                                                                    const Component = this.getPropertieComponent(k)
                                                                    if (!Component) {
                                                                        return null
                                                                    }

                                                                    if (!Component) {
                                                                        //console.error("UNABLE TO FIND COMPONENT FOR",k,cp[k])
                                                                        return null
                                                                    }

                                                                    return (
                                                                        <Item name={removeFieldType(k)}>
                                                                            <Component {...this.props} key={index} edit={this.state.edit}
                                                                                       propertie={k} value={cp[k]}
                                                                                       form={form}
                                                                                       onChange={(v) => this.onChange(k, v, p.id + "/" + cpIndex)}/>
                                                                        </Item>
                                                                    )
                                                                })}
                                                            </Section>
                                                        </Collapse.Panel>
                                                    )
                                                })}
                                            </Collapse>
                                        )
                                    }

                                    return null
                                })
                            )}
                        </>
                    )}
                </>
            </PermissionAlert>
        );
    }



    render() {
        if(this.props.mobile){
            return this.renderMobile()
        }
        return this.renderDesktop()
    }
}


function withNavigate(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigate(withActionSheet(FicheSubmit))

function Item({name,value,color,children,bold})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10,padding:"0 2.5%"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"flex-start",fontSize:15}}>

                <span style={{width:"40%",fontStyle:"italic",fontWeight:"300",color:"#333",fontSize:13}}>{name}</span>

                <div style={{display:"flex",textAlign:"right",alignItems:"flex-end",maxWidth:"60vw",overflow:"hidden",textOverflow:'ellipsis',color:color || MOBCOLORS.blue.color}}>
                    {value ?(
                        <span>{value.replaceAll("undefined","").trim() || t`[Inconnu]`}</span>
                    ):(
                        <div>{children}</div>
                    )}
                </div>
            </div>

            <div style={{width:"100%",paddingLeft:"5%",opacity:0.05}}>
                <div style={{width:"100%",borderTop:"1px solid #4A5568"}}/>
            </div>
        </div>
    )
}

function Section({title,children})
{
    return(
        <div style={{display:"flex",flexDirection:"column",gap:10}}>

            <div style={{display:"flex",flexDirection:"row",textAlign:"center",justifyContent:"center",alignItems:"center"}}>
                <span style={{color:"#333",fontSize:18,fontWeight:"300"}}>{title}</span>
            </div>

            <div style={{display:"flex",flexDirection:"column",gap:5,marginTop:10}}>
                {children}
            </div>
        </div>
    )
}
